import { useState, useEffect } from 'react';

import getVideoProviderByUrl from '../helpers/getVideoProviderByUrl';

const useVideoCaptions = ({ video, caption, ref, hasStarted }) => {
  const [hasCaptions, setHasCaptions] = useState(false);

  useEffect(() => {
    const getHasCaptions = async () => {
      if (!hasStarted) return;

      const player = ref.current?.getInternalPlayer;

      if (!player) return;

      const provider = getVideoProviderByUrl({ videoUrl: video });
      
      switch (provider) {
        case 'file': {
          setHasCaptions(Boolean(caption?.url));
          break;
        }
        case 'youtube': {
          const captions = player()?.getOptions('captions');
          setHasCaptions(captions.length > 0);
          break;
        }
        case 'vimeo': {
          const response = await player()?.getTextTracks();
          setHasCaptions(response?.length > 0);
          break;
        }
        default:   
      }
    }

    getHasCaptions();
  }, [video, caption, hasStarted]);

  return hasCaptions;
}

export default useVideoCaptions;
